import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./attachment-parent-form.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./attachment-parent-form.component.scss?ngResource";
import { Component, Input } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { AttachmentManagerHelper } from "../shared/attachment-manager-helper";
import { AttachmentManagerConstants } from "../shared/constants/attachment-manager.constant";
import { AttachmentManagerService } from "../shared/services/attachment-manager.service";
import { SharedConstants } from "../../../constants/shared.constants";
import { AppControllerService } from "../../../../app-controller.service";
import { AlertType } from "../../../models/alert";
import { CRUDOperation } from "../../../models/crud-operation-enum.model";
import { AutoUnsub } from "src/app/shared/decorators/autounsub.decorator";
import { AppConfig } from "src/app/app.config";
let AttachmentParentFormComponent = class AttachmentParentFormComponent {
    modalService;
    formBuilder;
    appController;
    attachmentMngService;
    titleLbl = AttachmentManagerConstants.TITLE_LBL;
    cancelBtnLbl = SharedConstants.CANCEL_LABEL;
    saveBtnLbl = SharedConstants.SAVE_LABEL;
    attachmentFormGroupFg = AttachmentManagerConstants.ATTACHMENT_FORM_GROUP;
    parentAttachmentFormGroup;
    submit;
    componentType;
    jobId;
    attachmentType;
    branding = {
        themeMainColor: SharedConstants.DEFAULT_COLOR,
        themeMainDarkerColor: SharedConstants.DEFAULT_DARKER_COLOR,
        themeMainBackgroundColor: SharedConstants.DEFAULT_COLOR,
        themeMainBorderColor: SharedConstants.DEFAULT_COLOR,
        themeHeaderBorderColor: SharedConstants.DEFAULT_HEADER_BORDER_COLOR,
        themeActiveColor: SharedConstants.DEFAULT_ACTIVE_COLOR,
        themeActiveAlternateColor: SharedConstants.DEFAULT_ACTIVE_ALTERNATE_COLOR,
        themePrimaryButtonColor: SharedConstants.DEFAULT_PRIMARY_BUTTON_COLOR
    };
    uploadAttachmentSubscription;
    constructor(modalService, formBuilder, appController, attachmentMngService) {
        this.modalService = modalService;
        this.formBuilder = formBuilder;
        this.appController = appController;
        this.attachmentMngService = attachmentMngService;
        if (AppConfig.settings.projectSettings && AppConfig.settings.projectSettings.styling) {
            this.branding = AppConfig.settings.projectSettings.styling;
        }
        this.parentAttachmentFormGroup = this.formBuilder.group({
            attachmentFormGroup: [],
        });
    }
    onBtnCancelClicked() {
        this.modalService.close();
    }
    saveAttachment() {
        this.submit = true;
        if (this.parentAttachmentFormGroup.valid) {
            const attachmentManager = this.parentAttachmentFormGroup.get(this.attachmentFormGroupFg).value;
            const formData = new FormData();
            for (const key in attachmentManager) {
                if (attachmentManager.hasOwnProperty(key)) {
                    formData.append(key, attachmentManager[key]);
                }
            }
            if (this.componentType == SharedConstants.ADD_PROJECT_CYCLE_COMPONENT_TYPE ||
                this.componentType == SharedConstants.EDIT_PROJECT_CYCLE_COMPONENT_TYPE) {
                this.uploadAttachmentSubscription = this.attachmentMngService.uploadProjectCycleAttachment(formData).subscribe({
                    next: (savedAttachment) => {
                        this.appController.showMessage(SharedConstants.ADD_SUCCESS, AlertType.Success);
                        this.modalService.close(savedAttachment);
                    }, error: (err) => {
                        AttachmentManagerHelper.errorHandler(err, this.appController, AttachmentManagerConstants.ADD_ATTACHMENT_COMPONENT, CRUDOperation.Add);
                    }
                });
            }
            else {
                this.uploadAttachmentSubscription = this.attachmentMngService.uploadAttachment(formData, this.jobId).subscribe({
                    next: (savedAttachment) => {
                        this.appController.showMessage(SharedConstants.ADD_SUCCESS, AlertType.Success);
                        this.modalService.close(savedAttachment);
                    }, error: (err) => {
                        AttachmentManagerHelper.errorHandler(err, this.appController, AttachmentManagerConstants.ADD_ATTACHMENT_COMPONENT, CRUDOperation.Add);
                    }
                });
            }
        }
        else {
            this.appController.showMessage(SharedConstants.FORM_NOT_VALID, AlertType.Warning);
        }
    }
    static ctorParameters = () => [
        { type: NgbActiveModal },
        { type: FormBuilder },
        { type: AppControllerService },
        { type: AttachmentManagerService }
    ];
    static propDecorators = {
        componentType: [{ type: Input }],
        jobId: [{ type: Input }],
        attachmentType: [{ type: Input }]
    };
};
AttachmentParentFormComponent = __decorate([
    Component({
        selector: "app-attachment-parent-form",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], AttachmentParentFormComponent);
export { AttachmentParentFormComponent };
